import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AccessibilityComponent} from './components/accessibility/accessibility.component';
import {LegalNoticeComponent} from './components/legal-notice/legal-notice.component';
import {SiteMapComponent} from './components/site-map/site-map.component';
import {IsAuthorizedService} from './modules/administration/services/is-authorized.service';
import {HomeAvisDePubComponent} from './modules/avisDePub/home-avis-de-pub/home-avis-de-pub.component';
import {ErrorComponent} from './modules/shared/components/error/error.component';
import {AccessDeniedComponent} from './modules/shared/components/access-denied/access-denied.component';
import {ProfilesComponent} from './modules/administration/profiles/profiles.component';
import {ProfilAcheteurComponent} from './modules/administration/profil-acheteur/profil-acheteur.component';

const routes: Routes = [
  {path: 'accueil', component: HomeAvisDePubComponent, pathMatch: 'full'},
  {
    path: 'avisdepublicite',
    loadChildren: () => import('./modules/avisDePub/avis-de-pub.module').then(m => m.AvisDePubModule),
    canActivate: [IsAuthorizedService]
  },
  {
    path: 'preferencesAvisPub',
    loadChildren: () => import('./modules/avisDePub/preferences-avis-de-pub/preferences.module').then(m => m.PreferencesModule),
    canActivate: [IsAuthorizedService]
  },
  {path: 'mention-legal', component: LegalNoticeComponent},
  {path: 'plan-du-site', component: SiteMapComponent},
  {path: 'accessibilite', component: AccessibilityComponent},
  {path: 'erreur', component: ErrorComponent},
  {path: 'acces-refuse', component: AccessDeniedComponent},
  {path: 'profiles', component: ProfilesComponent, canActivate: [IsAuthorizedService]},
  {path: 'authentifierProfilAcheteur', component: ProfilAcheteurComponent},
  {path: '**', component: HomeAvisDePubComponent}
];

@NgModule({
  providers: [],
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    scrollOffset: () => {
      const header = document.getElementById('errorsbloc');
      return [0, header ? header.offsetHeight + 90 : 0];
    }
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
